import React from 'react';
import { capitalize } from '../../../../utils';
import getUsersName from '../../../helpers/users/utils';

// Creates a column config for any populated array of users
const UserArrayColumn = (field, headerName, flex = 1) => ({
    field,
    headerName,
    flex,
    valueGetter: ({ row }) =>
        Array.isArray(row?.[field])
            ? row[field].map((u) => capitalize(getUsersName(u)).trim()).join(', ') // wrap
            : '',
});

export default UserArrayColumn;
